export const MA_MARKETPLACE_LIST_REQUEST = "MA_MARKETPLACE_LIST_REQUEST";
export const MA_MARKETPLACE_LIST_SUCCESS = "MA_MARKETPLACE_LIST_SUCCESS";
export const MA_MARKETPLACE_LIST_ERROR = "MA_MARKETPLACE_LIST_ERROR";
